/** @jsx jsx */
import { useEffect, useRef } from 'react'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import GroupGiftingForm from '~/components/Content/Forms/GroupGiftingForm'
import ReferralsForm from '~/components/Referrals/Form'
import TradeLandingForm from '~/components/Content/Forms/TradeLandingForm'
import VirtualEventForm from '~/components/Content/Forms/VirtualEventForm'

const FormSection = ({ bgOverride, description, footer, form, title }) => {
  let FormComponent = null

  const anchorRef = useRef(null)
  let anchorId

  const handleHeroCtaClick = (e) => {
    e.preventDefault()
    anchorRef.current.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    const heroCtaLink = document.querySelector(`a[href="#${anchorId}"]`)

    if (heroCtaLink) {
      // Smooth scroll from hero button to form anchor.
      heroCtaLink.removeEventListener('click', handleHeroCtaClick)
      heroCtaLink.addEventListener('click', handleHeroCtaClick)
    }
  }, []) // eslint-disable-line

  switch (form) {
    // Deprecated.
    case 'Group Gifting Landing':
      FormComponent = <GroupGiftingForm />
      anchorId = 'gift'
      break

    case 'Refer a Friend':
      FormComponent = <ReferralsForm />
      anchorId = 'start'
      break

    case 'Trade Landing':
      FormComponent = <TradeLandingForm />
      anchorId = 'contact'
      break

    case 'Virtual Events for Teams':
      FormComponent = <VirtualEventForm name="virtual-events-teams" />
      anchorId = 'schedule'
      break

    // Deprecated.
    case 'Virtual Happy Hour for Friends and Family':
      FormComponent = <VirtualEventForm name="virtual-happy-hour" />
      anchorId = 'schedule'
      break

    default:
      break
  }

  return (
    <Box
      bg={bgOverride}
      pt={[7, 9, null, 13]}
      pb={[8, 10, null, 14]}
      sx={{ position: 'relative' }}
    >
      <Box
        id={anchorId}
        ref={anchorRef}
        sx={{ position: 'absolute', top: '-100px' }}
      />
      <Container>
        <Grid columns={[1, 12]} sx={{ rowGap: '0', textAlign: 'center' }}>
          <Box sx={{ gridColumn: [null, '1 / -1', '2 / 12', '3 / 11'] }}>
            {title && (
              <Heading as="h2" variant="title2" mb={2}>
                {title}
              </Heading>
            )}
            {description && (
              <Box
                sx={{
                  variant: 'text.body1',
                  small: {
                    variant: 'text.body3',
                    backgroundColor: 'white',
                    display: 'block',
                    mt: 4,
                    px: 3,
                    py: 3,
                  },
                  'p:last-of-type': {
                    mb: 0,
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
          </Box>
          {FormComponent && (
            <Box
              mt={[4, null, 5]}
              sx={{ gridColumn: [null, '2 / 12', '3 / 11', '4 / 10'] }}
            >
              {FormComponent}
            </Box>
          )}
        </Grid>
        {footer && (
          <Box mt={[5, 7]} sx={{ textAlign: 'center' }}>
            <img
              src="/images/icons/cheers.svg"
              alt="An icon of two glasses touching each other"
            />
            <Box
              mt={3}
              sx={{
                variant: 'text.body2',
                h3: {
                  variant: 'text.title5',
                  mt: 0,
                  mb: 2,
                },
                p: {
                  m: 0,
                },
              }}
              dangerouslySetInnerHTML={{
                __html: footer.childMarkdownRemark.html,
              }}
            />
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default FormSection
